export const defaultChallangeImage = "https://assets.wesolv.com/challenge-pictures/default-challange.png";



// WEBPACK FOOTER //
// ./src/constants/defaultImages.js